import * as questionnaireType from "./questionnaireType";
import * as portalShared from "../portal/shared/metadataConstantsAndUtilities";


export const groupGraph = {
    "id": 111,
    "templateKey": "groupKey111",
    "publishedDate": "",
    "name": "",
    "nameQualifier": "",
    "description": "",
    "questionGroupType": "DEFAULT", // Could be LIKERT
    "visible": true,
    "metadata": {[portalShared.CUSTOM_DDO_NAME]: "hide"},
    "answerOptionTemplates": [],
    "questionTemplates": []
};


export const categoryGraph = {
    "id": 11,
    "templateKey": "categoryKey11",
    "publishedDate": "",
    "name": "",
    "nameQualifier": "",
    "description": "",
    "metadata": {[portalShared.CUSTOM_DDO_NAME]: "hide"},
    "groupTemplates": [groupGraph]
};


export const questionnaireGraph = {
    "id": 1,
    "templateKey": "questionnaireKey1",
    "publishedDate": "",
    "name": "",
    "nameQualifier": "",
    "description": "",
    "metadata": {},
    "questionnaireType": questionnaireType.QUESTIONNAIRE_COMPLEX, // Currently the only type allowed, Legacy types were deprecated
    "questionTemplates": [], // Deprecated from questionnaireType "SIMPLE" which allow questions to be tied to a questionnaire
    "questionCategoryTemplates": [categoryGraph],
};





